import * as Sentry from '@sentry/vue'
import Vue from 'vue'
import VueResource from 'vue-resource'
import { getWithDotNotation, hasPermission } from './utils'
import VueTheMask from 'vue-the-mask'
import Toasted from 'vue-toasted'
import store from './store/store'
import VueOffline from 'vue-offline'
import Cookies from 'js-cookie'
import router from './router/router'
import UsarSentry from './sentry'

import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import { formatarObjetoWebParaSentry } from './sentry.ts'

Vue.use(VueOffline)
Vue.use(VueTheMask)
Vue.use(Toasted)
Vue.use(VueResource)

Vue.http.interceptors.push((request, next) => {
  NProgress.start()
  next((response) => {
    NProgress.done()
  })
})
// Inteceptor relacionado ao Cadastro SSO
Vue.http.interceptors.push((request, next) => {
  const tokenJWTRegex = /^Bearer [A-Za-z0-9-_=]+\.[A-Za-z0-9-_=]+\.?[A-Za-z0-9-_.+/=]*$/
  const { cognitoInfo } = store.state.accessData
  const getSolarToken = () => {
    const token = Cookies.get('Authorization') ||
    (store && store.state && store.state.accessData && store.state.accessData.solarInfo && store.state.accessData.solarInfo.authorization)

    if (typeof token === 'string' && token.match(tokenJWTRegex)) {
      return token
    }
    return null
  }
  const tokenSolar = getSolarToken()

  let token

  if (tokenSolar) {
    token = tokenSolar
  } else {
    token = cognitoInfo ? cognitoInfo.accessToken : null
  }

  if (
    request.url.includes('/coletores/pessoal/sso')
  ) {
    request.headers.set('Authorization', token)
  }
  next()
})
// Inteceptor relacionado ao Cadastro de Coletor
Vue.http.interceptors.push((request, next) => {
  const tokenJWTRegex = /^Bearer [A-Za-z0-9-_=]+\.[A-Za-z0-9-_=]+\.?[A-Za-z0-9-_.+/=]*$/
  const { cognitoInfo } = store.state.accessData
  const getSolarToken = () => {
    const token = Cookies.get('Authorization') ||
    (store && store.state && store.state.accessData && store.state.accessData.solarInfo && store.state.accessData.solarInfo.authorization)

    if (typeof token === 'string' && token.match(tokenJWTRegex)) {
      return token
    }
    return null
  }
  const tokenSolar = getSolarToken()
  let token

  if (store.state.accessData.solarInfo) {
    token = tokenSolar
  } else if (cognitoInfo) {
    token = cognitoInfo.accessToken
  } else {
    token = 'Bearer ' + store.state.accessData.regularToken
  }
  if (
    request.url.includes('/coletores') ||
    request.url.includes('/coletor') ||
    request.url.includes('/perfis-de-coletor') ||
    request.url.includes('/locais') ||
    request.url.includes('/renovar-chave-dispositivo') ||
    request.url.includes('/logar-dispositivo') ||
    request.url.includes('/empregados')
  ) {
    request.headers.set('Authorization', token)
  }
  next()
})

// Interceptor relacionado a sincronizacao/marcacao
Vue.http.interceptors.push((request, next) => {
  const tokenColetor = store.state.accessData.coletor.tokenColetor

  if (!tokenColetor) {
    Sentry.captureEvent({
      message: 'Coletor sem token no interceptor',
      contexts: {
        localStorage: {
          web: formatarObjetoWebParaSentry(window.localStorage.getItem('web'))
        }
      }
    })
  }

  const token = 'Bearer ' + tokenColetor

  if (request.url.includes('/infos-extras-marcacoes/audio')) {
    request.headers.set('Content-Type', 'multipart/form-data')
  }
  if (
    request.url.includes('/sincronizacao-web') ||
    request.url.includes('/validacoes-pre-marcacao') ||
    request.url.includes('/marcacao') ||
    request.url.includes('/infos-extras-marcacoes') ||
    request.url.includes('/comprovante') ||
    request.url.includes('/horario-do-local') ||
    request.url.includes('/horario-localizacao') ||
    request.url.includes('/horario-timezone') ||
    request.url.includes('/layout-customizado') ||
    request.url.includes('/urls-de-redirecionamento/bate-ponto')
  ) {
    request.headers.set('Authorization', token)
  }
  next()
})

Vue.http.interceptors.push(function (request, next) {
  if (
    request.url.includes('web/login-cognito') ||
    request.url.includes('/api/auth-logout')
  ) {
    request.headers.set('X-PontoTel-Authorization', store.state.accessData.cognitoInfo.accessToken)
    request.headers.set('X-PontoTel-UP', store.state.accessData.cognitoInfo.userPoolId)
    request.headers.set('X-PontoTel-DI', store.state.accessData.cognitoInfo.userPoolWebClientId)
  }
  next()
})

Vue.http.interceptors.push(_ => {
  return response => {
    if (response.status === 403 && response.bodyText === 'Esse ip não está autorizado para fazer requisições') {
      router.push('/acesso-negado')
    }
  }
})

Vue.http.interceptors.push((request, next) => {
  const regexUrlGerenciadorColetor = /https:\/\/bateponto\.pontotel\.com\.br\/pontotel\/gerenciador-de-coletores-web/
  const clienteId = store.state.accessData?.coletor?.clientId
  const idsCanary = [
    '575eb492891f5b01880d4529',
    '6151f5a9e1287f240ec87b08',
    '6152034f92a74fce18ee06b3',
    '5ec3fdc8081fe00009452bd4',
    '5cfea5a86452bb0016659ef5',
    '5d814399a1610c001830c366',
    '55f19e4c2a283c00f9b18663',
    '5c61c3fcfcead500111177d1',
    '5e2ade6f819517000de94f39',
    '5db769e5342dc52c0ba7a8f1',
    '649daea038caac1cea16306f',
    '654d1d2cd71c34b3f9a72a53',
    '6553b66d57d15d656e56efec',
    '6553b6f2075447264c9af57f',
    '655662237f20c84e5d008412',
    '6556712bd7d728b541bda179',
    '6556733cd7d728b541bda17b',
    '655674093966b56539a6847d',
    '65567846d7d728b541bda17c',
    '65574fb898e8a0a183b474e8',
    '656502c737b931cf34244f1a',
    '656749db493c1b3d95d3f130',
    '656749ec493c1b3d95d3f6c9',
    '656749fb493c1b3d95d3fc61',
    '65674a0a493c1b3d95d401f9',
    '65674a16493c1b3d95d40791',
    '65674a24493c1b3d95d40d29',
    '65674a31493c1b3d95d412c1',
    '65674a3c493c1b3d95d41859',
    '65674a49493c1b3d95d41df1',
    '65674a56493c1b3d95d42389',
    '65674a63493c1b3d95d42921',
    '65674a71493c1b3d95d42eb9',
    '65674a7f493c1b3d95d43451'
  ]
  if (regexUrlGerenciadorColetor.test(request.url) && idsCanary.includes(clienteId)) {
    const urlCanary = 'https://bateponto.pontotel.com.br/cloud-run-canary/gerenciador-de-coletores-web'
    const urlFormatada = request.url.replace(regexUrlGerenciadorColetor, urlCanary)
    request.url = urlFormatada
  }

  if (request.urlBaseParaRetry && !idsCanary.includes(clienteId)) {
    const urlFormatada = request.url.replace(regexUrlGerenciadorColetor, request.urlBaseParaRetry)
    UsarSentry.capturarEvento('Enviando requisição para cloud-run', 'info', {
      urlOriginal: request.url,
      urlRetry: urlFormatada,
      clienteId: clienteId,
      timeStamp: new Date().toISOString()
    })
    request.url = urlFormatada
  }
  next()
})

export const mixins = {
  methods: {
    $getterUseState: (useState) => getWithDotNotation(store.state, useState, '/'),
    $dispatchUseState: (useState, payload) => store.dispatch(useState, payload),
    $commitUseState: (useState, payload) => store.commit(useState, payload)
  }
}

Vue.prototype.$hasPermission = hasPermission
Vue.mixin(mixins)
